import {
  ClickAwayListener,
  Grow,
  IconButton,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Typography,
} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import { Language } from '@material-ui/icons';
import clsx from 'clsx';
import i18n, { changeLanguage } from 'i18n';
import React from 'react';
import options from './options';
import styles from './styles';

const useStyles = makeStyles(styles);

export interface Props {
  insideTemplate?: boolean;
}

const ChangeLanguage: React.FC<Props> = ({ insideTemplate }) => {
  const classes = useStyles();
  const anchorRef = React.useRef<HTMLButtonElement>(null);
  const [openMenu, setOpenMenu] = React.useState<boolean>(false);

  const language = i18n.language || 'pt-BR';

  return (
    <Grid
      container
      justify="flex-end"
      className={classes.changeLanguageContainer}
      data-testid={'autosky-changelanguage'}
    >
      <ClickAwayListener onClickAway={() => setOpenMenu(false)}>
        <div>
          <IconButton
            className={clsx(classes.languageButton, {
              [classes.languageButtonInsideTemplate]: insideTemplate,
            })}
            ref={anchorRef}
            onClick={() => setOpenMenu(!openMenu)}
          >
            <Language />
          </IconButton>

          <Popper
            open={openMenu}
            placement="bottom-end"
            anchorEl={anchorRef.current}
            transition
            disablePortal
          >
            {({ TransitionProps }) => (
              <Grow {...TransitionProps}>
                <Paper>
                  <MenuList className={classes.languageList}>
                    {options(changeLanguage).map((item, index) => (
                      <MenuItem
                        key={index}
                        className={clsx(classes.languageItem, {
                          [classes.selectedLanguage]: item.language.test(
                            language
                          ),
                        })}
                        onClick={() => {
                          item.action();
                          setOpenMenu(false);
                        }}
                      >
                        <Typography>{item?.text}</Typography>
                      </MenuItem>
                    ))}
                  </MenuList>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
      </ClickAwayListener>
    </Grid>
  );
};

export default ChangeLanguage;
